import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import { FieldConfig } from './AmortizationCalculator.utils.js';
import { isEditor } from '../../utils/isEditor.js';
import AmortizationCalculator from './AmortizationCalculator.js';

var AmortizationCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var amount = attrs.amount,
      term = attrs.term,
      rate = attrs.rate,
      startMonth = attrs.startMonth,
      startYear = attrs.startYear;
    var defaultValues = {
      amount: amount,
      term: term,
      rate: rate,
      startMonth: startMonth,
      startYear: startYear
    };
    return /*#__PURE__*/React.createElement(AmortizationCalculator, _extends({
      defaultValues: defaultValues
    }, isEditor() && {
      editorMode: true,
      key: JSON.stringify(defaultValues)
    }));
  },
  metadata: {
    $schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'constellation/amortization-calculator',
    title: 'Amortization Calculator',
    description: 'Amortization calculator',
    icon: 'businessperson',
    keywords: ['Amortization', 'Calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'more',
    attributes: {
      amount: {
        type: 'number',
        default: 200000,
        label: 'Loan amount',
        control: 'number'
      },
      term: {
        type: 'string',
        default: LOAN_PROGRAMS.fixed30Year,
        label: 'Loan program',
        control: 'select',
        choices: FieldConfig.term.options
      },
      rate: {
        type: 'number',
        label: 'Interest rate',
        default: 4.176,
        control: 'number'
      },
      startMonth: {
        type: 'string',
        default: 'Aug',
        label: 'Loan start date',
        control: 'select',
        choices: [{
          label: 'Jan',
          value: 'Jan'
        }, {
          label: 'Feb',
          value: 'Feb'
        }, {
          label: 'Mar',
          value: 'Mar'
        }, {
          label: 'Apr',
          value: 'Apr'
        }, {
          label: 'May',
          value: 'May'
        }, {
          label: 'Jun',
          value: 'Jun'
        }, {
          label: 'Jul',
          value: 'Jul'
        }, {
          label: 'Aug',
          value: 'Aug'
        }, {
          label: 'Sep',
          value: 'Sep'
        }, {
          label: 'Oct',
          value: 'Oct'
        }, {
          label: 'Nov',
          value: 'Nov'
        }, {
          label: 'Dec',
          value: 'Dec'
        }]
      },
      startYear: {
        type: 'number',
        default: 2024,
        label: 'Loan start date',
        control: 'select',
        choices: [{
          label: 'Loan start date low',
          value: 1900
        }, {
          label: 'Loan start date high',
          value: 2100
        }]
      }
    }
  }
};
var AmortizationCalculatorBlock$1 = AmortizationCalculatorBlock;

export { AmortizationCalculatorBlock$1 as default };
